export default {
    countHours(data_semesters) {
        let total_hours = 0

        data_semesters.forEach((item_semester) => {
            let curr_hours = item_semester.hours.reduce((current_sum, hour) => {
                return current_sum + hour.value
            }, 0)

            total_hours += curr_hours
        })

        return total_hours
    },
    descriptionHours(data_semesters) {
        let dict_type_work_hours = {}
        let result_content = ''

        data_semesters.forEach((item_semester) => {
            item_semester.hours.forEach((hour) => {
                if (!dict_type_work_hours[`${hour.load}`]) {
                    dict_type_work_hours[`${hour.load}`] = 0
                }
                dict_type_work_hours[`${hour.load}`] += hour.value
            })
        })

        let last_el = Object.keys(dict_type_work_hours)[Object.keys(dict_type_work_hours).length - 1]

        for (let key in dict_type_work_hours) {
            result_content += `${key} – ${dict_type_work_hours[key]} акад. час${last_el === key ? '.' : ', '}`
        }

        return result_content
    },
    descriptionFormControl(data_semesters) {
        return data_semesters.reduce((current_content, data_semester, index) => {
            let str_format_controls = data_semester.format_controls.reduce((current_str, format_control, index_format_control) => {
                return current_str + `${format_control}${index_format_control === data_semester.format_controls.length - 1 ? '' : ', '}`
            }, '')

            return current_content + `${data_semester.semester_name} – ${str_format_controls}${index === data_semesters.length - 1 ? '.' : '; '}`
        }, '')
    },
    contentTechMap(data_table){
        let result_content = [
            [
                {text: '№ раздела (модуля)', alignment: 'center'},
                {text: 'Название раздела (модуля) Темы лекций', alignment: 'center'},
                {text: 'Лекция', alignment: 'center'},
                {text: 'Практическое занятие', alignment: 'center'},
                {text: 'Лабораторная работа', alignment: 'center'},
                {text: 'СРС', alignment: 'center'},
                {text: 'Контроль', alignment: 'center'}
            ]
        ]

        data_table.forEach((tm_el) => {
            result_content.push([{text: tm_el.semester, colSpan: 7, alignment: 'center'},'','','','','',''])

            tm_el.data_tech_map.forEach((module_tm, index) => {
                if (module_tm.items) {
                    result_content.push([
                        {text: index + 1, rowSpan: module_tm.items.length, alignment: 'center'},
                        {text: module_tm.name, colSpan: 6, alignment: 'center'},
                        '','','','',''
                    ])

                    module_tm.items.forEach((inner_module_tm) => {
                        result_content.push([
                            '',
                            {text: inner_module_tm.name},
                            {text: inner_module_tm.types_lecture, alignment: 'center'},
                            {text: inner_module_tm.types_practical_training, alignment: 'center'},
                            {text: inner_module_tm.types_laboratory_work, alignment: 'center'},
                            {text: inner_module_tm.types_students_independent_work, alignment: 'center'},
                            {text: inner_module_tm.types_final_control, alignment: 'center'}
                        ])
                    })
                } else {
                    result_content.push([
                        {text: index + 1, alignment: 'center'},
                        {text: module_tm.name},
                        {text: module_tm.types_lecture, alignment: 'center'},
                        {text: module_tm.types_practical_training, alignment: 'center'},
                        {text: module_tm.types_laboratory_work, alignment: 'center'},
                        {text: module_tm.types_students_independent_work, alignment: 'center'},
                        {text: module_tm.types_final_control, alignment: 'center'}
                    ])
                }
            })
        })

        return result_content
    },
    shortName(full_name){
        let parts_name = full_name.split(' ')

        return `${parts_name[0]} ${parts_name[1][0]}.${parts_name[2][0]}.`
    },
    listParticipants(list_cofounders, full_name){
        let result = [
            [{text: 'Авторы', alignment: 'left'}, {text: `${full_name}`, alignment: 'right'}]
        ]

        list_cofounders.forEach((cofounder) => {
            result.push([{text: '', alignment: 'left'}, {text: `${cofounder}`, alignment: 'right'}])
        })

        return result
    },
    createPDF(data_tm) {
        pdfMake.fonts = {
            Times: {
                normal: 'TimesNewRomanCyrRegular.TTF',
                bold: 'TimesNewRomanCyrBold.TTF',
                italics: 'TimesNewRomanCyrItalic.TTF',
                bolditalics: 'TimesNewRomanCyrBoldItalic.TTF'
            }
        };
        const docInfo = {
            info: {
                title: `Технологическая карта электронного учебного курса`,
                author: 'АмГУ',
                subject: '',
                keywords: ''
            },

            pageSize: 'A4',
            pageOrientation: 'portrait',

            content: [
                {
                    text: 'Технологическая карта электронного учебного курса\n' +
                        `«${data_tm.course_full_name}»`,
                    style: 'title'
                },
                {
                    text: `${data_tm.type_course === 'Стандарт' ? '' : '(Для всех направлений подготовки)'}`,
                    style: 'subtitle'
                },
                {
                    text: '\n',
                    style: 'base_text'
                },
                {
                    text: [
                        {text: 'Продолжительность обучения: '},
                        {
                            text: `${this.countHours(data_tm.data_training.data_semesters)} акад. часа: ` +
                                `${this.descriptionHours(data_tm.data_training.data_semesters)}`,
                            decoration: 'underline'
                        }
                    ],
                    style: 'base_text'
                },
                {
                    text: [
                        {
                            text: 'Форма контроля: '
                        },
                        {
                            text: `${this.descriptionFormControl(data_tm.data_training.data_semesters)}`,
                            decoration: 'underline',
                        }
                    ],
                    style: 'base_text'
                },
                {
                    text: '\n', style: 'base_text'
                },
                {
                    style: 'tableBase',
                    table: {
                        // widths: [200, 'auto', 'auto'],
                        body: this.contentTechMap(data_tm?.data_technological_map?.data_table || data_tm?.technological_map_data?.data_table)

                    }
                },
                {
                    text:'\n\n', style: 'base_text'
                },
                {
                    style: 'tableSupport',
                    table: {
                        widths: ['50%', '50%'],
                        body: this.listParticipants(data_tm.cofounders, data_tm.full_name)

                    },
                    layout: 'noBorders'
                }
            ],

            styles: {
                base_text: {
                    fontSize: 14,
                    alignment: 'justify',
                    font: 'Times'
                },
                title: {
                    fontSize: 14,
                    alignment: 'center',
                    bold: true,
                    font: 'Times'
                },
                subtitle:{
                    fontSize: 12,
                    alignment: 'center',
                    bold: true,
                    font: 'Times'
                },
                header: {
                    fontSize: 9,
                    alignment: 'center',
                    font: 'Times'
                },
                normal: {
                    fontSize: 9,
                    alignment: 'justify',
                    font: 'Times',
                    leadingIndent: 18
                },
                column: {
                    fontSize: 9,
                    alignment: 'left',
                    font: 'Times'
                },
                tableBase: {
                    fontSize: 12,
                    font: 'Times'
                },
                tableSupport: {
                    fontSize: 14,
                    font: 'Times'
                }
            }
        }
        pdfMake.createPdf(docInfo).download(`Технологическая карта - ${data_tm.course_full_name}.pdf`);
    }
}